import React from 'react';
import Interweave from 'interweave';

import { Box, Button, Typography } from '@mui/material';

import BlockFactory from './BlockFactory';
import BlockEditHeader from './BlockEditHeader';
import BlockEditFooter from './BlockEditFooter';

import ColorPallet from './ColorPallet';
import ScaleBar from './ScaleBar';
import YoutubeInfoInput from './YoutubeInfoInput';
import NoImageIcon from 'icons/drawable/ic_img_empty.svg';

function YoutubeBlockEditView({idx, iconChar, iconColor, block, onUpdate, onDelete, onDone, onCancel}) {

	const [optionMode,setOptionMode] = React.useState();
	const [backgroundColor,setBackgroundColor] = React.useState(block.backgroundColor);
	const [scale,setScale] = React.useState(block.scale === undefined ? 1 : block.scale);
	const [translationX,setTranslationX] = React.useState(block.translationX === undefined ? 0 : block.translationX);
	const [videoId,setVideoId] = React.useState(block.data);


	const getUpdatedBlock = (b, s, t, v) => {
		let updatedBlock = BlockFactory.clone(block);
		updatedBlock.backgroundColor = b;
		updatedBlock.scale = s;
		updatedBlock.translationX = t;
		updatedBlock.data = v;
		return updatedBlock;
	};

	const handleBackgroundColorChange = (v) => {
		let newBackgroundColor = v;
		setBackgroundColor(newBackgroundColor);
		if (onUpdate) {
			onUpdate(getUpdatedBlock(newBackgroundColor, scale, translationX, videoId));
		}
	};

	const handleScaleChange = (v) => {
		let newScale = v / 100;
		setScale(newScale);
		if (onUpdate) {
			onUpdate(getUpdatedBlock(backgroundColor, newScale, translationX, videoId));
		}
	};

	const handleTranslationXChange = (v) => {
		let newTranslationX = (v - 50) * 2;
		setTranslationX(newTranslationX);
		if (onUpdate) {
			onUpdate(getUpdatedBlock(backgroundColor, scale, newTranslationX, videoId));
		}
	};

	const handleYoutubeInfoChange = (newInfo) => {
		setVideoId(newInfo.videoId);
		if (onUpdate) {
			onUpdate(getUpdatedBlock(backgroundColor, scale, translationX, newInfo.videoId));
		}
	};

	const handleDelete = () => {
		if (onDelete) {
			onDelete(block);
		}
	};

	const handleDone = () => {
		if (onDone) {
			onDone(getUpdatedBlock(backgroundColor, scale, translationX, videoId));
		}
	};

	const handleCancel = () => {
		if (onCancel) {
			onCancel(block);
		}
	};

	const getVideoArea = () => {
		if (!videoId) {
			return (
				<div
					style={{
						width: '100%',
						height: `${140/360 * 100}vw`,
						borderRadius: `${5.6/360 * 100}vw`,
						backgroundColor: '#f2f2f2',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<img src={NoImageIcon} alt="not set icon"/>
					<Typography
						fontFamily='노토산스 Regular'
						fontSize={`${14/360 * 100}vw`}
						color='#aeaeae'
						sx={{
							marginTop: `${10/360 * 100}vw`
						}}
					>
						YouTube URL을 입력하세요
					</Typography>
				</div>
			);
		}

		const iframeStyle = {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			borderWidth: 0,
			//border:'2px solid yellow',
			transform: `translateX(${translationX}%) scale(${scale})`,
		};

		return (
			<div
				style={{
					width:'100%',
					paddingTop:'56.25%',	// 16:9 aspect ratio
					backgroundColor: backgroundColor,
					//border:'2px solid red',
					overflow: 'hidden',
					position: 'relative',
				}}
			>
				<iframe
					style={iframeStyle}
					src={`https://www.youtube.com/embed/${videoId}`}
					frameBorder="0"
					allowFullScreen
				/>
			</div>
		);
	}

	const getButtons = () => {
		const btnFontSize = 14;
		const btnTextMargin = -10;

		return (
			<Box
				display='flex'
				flexDirection='row'
				justifyContent='center'
				alignItems='center'
				sx={{
					width:'100%',
					marginTop: `${20/360 * 100}vw`,
				}}
			>
				<Button
					variant="outlined"
					sx={{
						bgcolor: optionMode === 'color' ? '#336cadff' : 'white',
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${74/360 * 100}vw`,
						height: `${30/360 * 100}vw`,
						marginRight: `${8/360 * 100}vw`,
					}}
					onClick={e => setOptionMode(optionMode === 'color' ? undefined : 'color')}
				>
					<Typography
						fontFamily='노토산스 Bold'
						fontSize={`${btnFontSize/360 * 100}vw`}
						color={optionMode === 'color' ? 'white' : '#6cadff'}
						sx={{margin:`${btnTextMargin}px`}}
					>
						배경색상
					</Typography>
				</Button>
				<Button
					variant="outlined"
					sx={{
						bgcolor: optionMode === 'scale' ? '#336cadff' : 'white',
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${74/360 * 100}vw`,
						height: `${30/360 * 100}vw`,
						marginRight: `${8/360 * 100}vw`,
					}}
					onClick={e => setOptionMode(optionMode === 'scale' ? undefined : 'scale')}
				>
					<Typography
						fontFamily='노토산스 Bold'
						fontSize={`${btnFontSize/360 * 100}vw`}
						color={optionMode === 'scale' ? 'white' : '#6cadff'}
						sx={{margin:`${btnTextMargin}px`}}
					>
						사이즈
					</Typography>
				</Button>
				<Button
					variant="outlined"
					sx={{
						bgcolor: optionMode === 'translationX' ? '#336cadff' : 'white',
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${74/360 * 100}vw`,
						height: `${30/360 * 100}vw`,
						marginRight: `${8/360 * 100}vw`,
					}}
					onClick={e => setOptionMode(optionMode === 'translationX' ? undefined : 'translationX')}
				>
					<Typography
						fontFamily='노토산스 Bold'
						fontSize={`${btnFontSize/360 * 100}vw`}
						color={optionMode === 'translationX' ? 'white' : '#6cadff'}
						sx={{margin:`${btnTextMargin}px`}}
					>
						좌우정렬
					</Typography>
				</Button>
				<Button
					variant="contained"
					sx={{
						bgcolor: optionMode === 'videoId' ? '#336cadff' : "#6cadff",
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${74/360 * 100}vw`,
						height: `${30/360 * 100}vw`,
					}}
					onClick={e => setOptionMode(optionMode === 'videoId' ? undefined : 'videoId')}
				>
					<Typography
						fontFamily='노토산스 Bold'
						fontSize={`${btnFontSize/360 * 100}vw`}
						color='white'
						sx={{margin:`${btnTextMargin}px`}}
					>
						URL
					</Typography>
				</Button>
			</Box>
		);
	};

	const getOptionalSetting = () => {
		if (optionMode === 'color') {
			return (
				<ColorPallet curColorValue={backgroundColor} onUpdate={handleBackgroundColorChange}/>
			);
		}
		else if (optionMode === 'scale') {
			return (
				<ScaleBar value={scale * 100} onUpdate={handleScaleChange}/>
			);
		}
		else if (optionMode === 'translationX') {
			return (
				<ScaleBar value={(translationX / 2) + 50} onUpdate={handleTranslationXChange}/>
			);
		}
		else if (optionMode === 'videoId') {
			let youtubeInfo = { videoId: videoId };
			return (
				<YoutubeInfoInput value={youtubeInfo} onUpdate={handleYoutubeInfoChange}/>
			);
		}
	};

	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			sx={{
				left:`${20/360 * 100}vw`,
				width:`${320/360 * 100}vw`,
			}}
		>
			<BlockEditHeader
				blockName={block.name}
				iconChar={iconChar}
				iconColor={iconColor}
				onDelete={onDelete ? () => handleDelete() : undefined}
			/>
			{getVideoArea()}
			{getButtons()}
			{getOptionalSetting()}
			{
				onDone && onCancel &&
				<BlockEditFooter
					onDone={e => handleDone()}
					onCancel={e => handleCancel()}
				/>
			}
		</Box>
	);
}

export default YoutubeBlockEditView;
